import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { getPanels } from '_helpers';
import { ObservationPosturePelvicGirdle } from './ObservationPosturePelvicGirdle'
import { ObservationPostureGlutealFold } from './ObservationPostureGlutealFold'
import { ObservationPosturePoplitealCrease } from './ObservationPosturePoplitealCrease'
import { ObservationPostureHeelPosition } from './ObservationPostureHeelPosition'
import { ObservationPostureFootPosition } from './ObservationPostureFootPosition'
import { ObservationPostureGlenohumeralJoint } from './ObservationPostureGlenohumeralJoint'
import { ObservationPostureScapularPosition } from './ObservationPostureScapularPosition'
import { ObservationPostureElbowPosition } from './ObservationPostureElbowPosition'
import { ObservationPostureHeadPosition } from './ObservationPostureHeadPosition'
import { ObservationPostureChinNeckAngle } from './ObservationPostureChinNeckAngle'
import { ObservationPostureRibAngle } from './ObservationPostureRibAngle'
import { ObservationPostureSpine } from './ObservationPostureSpine'
import { ObservationPostureComments } from './ObservationPostureComments'

const components = {
    ObservationPosturePelvicGirdle,
    ObservationPostureGlutealFold,
    ObservationPosturePoplitealCrease,
    ObservationPostureHeelPosition,
    ObservationPostureFootPosition,
    ObservationPostureGlenohumeralJoint,
    ObservationPostureScapularPosition,
    ObservationPostureElbowPosition,
    ObservationPostureHeadPosition,
    ObservationPostureChinNeckAngle,
    ObservationPostureRibAngle,
    ObservationPostureSpine,
    ObservationPostureComments
}

class PatientCareCenterNoteObjectiveObsPosture extends React.Component {

    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSection id='obj_obs_posture' name='Posture' level={2} noChildPadding={true}>
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return this.renderChild(this.props.panels[key].MOPNAME, this.props.panels[key].MOPNO);
                            })

                    }
                </PatientCareCenterNoteSection>
            );
        } else {
            return (
                <span />
            )
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        noteId: noteId,
        panels: getPanels(noteId, 'Observation', 'Posture')
    };
}

const connectedPatientCareCenterNoteObjectiveObsPosture = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsPosture);
export { connectedPatientCareCenterNoteObjectiveObsPosture as PatientCareCenterNoteObjectiveObsPosture };

